export default __webpack_public_path__ + "static/media/filling-only.46d136ab.webp";